var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tile is-ancestor is-parent" }, [
    _c("div", { staticClass: "tile" }, [
      _c("div", { staticClass: "tile is-parent is-half" }, [
        _c("article", { staticClass: "tile is-child box" }, [
          _vm._m(0),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Item No.")]),
            _c("span", [_vm._v(_vm._s(_vm.value.itemNo))]),
          ]),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Description")]),
            _c("div", { staticClass: "field-body" }, [
              _c("div", { staticClass: "control desc-width" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.value.itemDesc,
                      expression: "value.itemDesc",
                    },
                    { name: "focus-inserted", rawName: "v-focus-inserted" },
                  ],
                  staticClass: "input",
                  class: { "is-danger": _vm.$v.entity.itemDesc.$error },
                  attrs: {
                    name: "itemDesc",
                    type: "text",
                    placeholder: "Description",
                    maxlength: "100",
                  },
                  domProps: { value: _vm.value.itemDesc },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.value, "itemDesc", $event.target.value)
                    },
                  },
                }),
                _vm.$v.entity && !_vm.$v.entity.itemDesc.required
                  ? _c("span", { staticClass: "help is-danger" }, [
                      _vm._v("Description is required"),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "field" }, [
            _c("div", { staticClass: "control is-narrow" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Allow Tick")]),
              _vm.isLabourTypeVisible("FIBER")
                ? _c("span", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.cbFiber,
                          expression: "cbFiber",
                        },
                      ],
                      staticClass: "is-checkradio",
                      attrs: { type: "checkbox", id: "cbFiber" },
                      domProps: {
                        checked: Array.isArray(_vm.cbFiber)
                          ? _vm._i(_vm.cbFiber, null) > -1
                          : _vm.cbFiber,
                      },
                      on: {
                        click: function ($event) {
                          _vm.cbFiber = !_vm.cbFiber
                          _vm.showHide("fiber", _vm.cbFiber)
                        },
                        change: function ($event) {
                          var $$a = _vm.cbFiber,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.cbFiber = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.cbFiber = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.cbFiber = $$c
                          }
                        },
                      },
                    }),
                    _c("label", { attrs: { for: "cbFiber" } }, [
                      _vm._v("Fiberglass"),
                    ]),
                  ])
                : _vm._e(),
              _vm.isLabourTypeVisible("CRUSH")
                ? _c("span", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.cbCrush,
                          expression: "cbCrush",
                        },
                      ],
                      staticClass: "is-checkradio",
                      attrs: { type: "checkbox", id: "cbCrush" },
                      domProps: {
                        checked: Array.isArray(_vm.cbCrush)
                          ? _vm._i(_vm.cbCrush, null) > -1
                          : _vm.cbCrush,
                      },
                      on: {
                        click: function ($event) {
                          _vm.cbCrush = !_vm.cbCrush
                          _vm.showHide("crush", _vm.cbCrush)
                        },
                        change: function ($event) {
                          var $$a = _vm.cbCrush,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.cbCrush = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.cbCrush = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.cbCrush = $$c
                          }
                        },
                      },
                    }),
                    _c("label", { attrs: { for: "cbCrush" } }, [
                      _vm._v("Crush"),
                    ]),
                  ])
                : _vm._e(),
              _vm.isLabourTypeVisible("CD")
                ? _c("span", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.cbCD,
                          expression: "cbCD",
                        },
                      ],
                      staticClass: "is-checkradio",
                      attrs: { type: "checkbox", id: "cbCD" },
                      domProps: {
                        checked: Array.isArray(_vm.cbCD)
                          ? _vm._i(_vm.cbCD, null) > -1
                          : _vm.cbCD,
                      },
                      on: {
                        click: function ($event) {
                          _vm.cbCD = !_vm.cbCD
                          _vm.showHide("cd", _vm.cbCD)
                        },
                        change: function ($event) {
                          var $$a = _vm.cbCD,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.cbCD = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.cbCD = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.cbCD = $$c
                          }
                        },
                      },
                    }),
                    _c("label", { attrs: { for: "cbCD" } }, [
                      _vm._v("Clean and Detail"),
                    ]),
                  ])
                : _vm._e(),
              _vm.isLabourTypeVisible("MECH")
                ? _c("span", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.cbMech,
                          expression: "cbMech",
                        },
                      ],
                      staticClass: "is-checkradio",
                      attrs: { type: "checkbox", id: "cbMech" },
                      domProps: {
                        checked: Array.isArray(_vm.cbMech)
                          ? _vm._i(_vm.cbMech, null) > -1
                          : _vm.cbMech,
                      },
                      on: {
                        click: function ($event) {
                          _vm.cbMech = !_vm.cbMech
                          _vm.showHide("mech", _vm.cbMech)
                        },
                        change: function ($event) {
                          var $$a = _vm.cbMech,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.cbMech = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.cbMech = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.cbMech = $$c
                          }
                        },
                      },
                    }),
                    _c("label", { attrs: { for: "cbMech" } }, [
                      _vm._v("Mechanical"),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ]),
          _c("div", { staticClass: "field" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isFiber && _vm.isLabourTypeVisible("FIBER"),
                    expression: "isFiber && isLabourTypeVisible('FIBER')",
                  },
                ],
                staticClass: "field-body",
              },
              [
                _c("div", { staticClass: "field is-narrow" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Fiberglass Hour"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _c("vue-numeric", {
                        staticClass: "input has-text-right",
                        attrs: { min: 0.0, precision: 2 },
                        model: {
                          value: _vm.value.fgHour,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "fgHour", _vm._n($$v))
                          },
                          expression: "value.fgHour",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isCrush && _vm.isLabourTypeVisible("CRUSH"),
                    expression: "isCrush && isLabourTypeVisible('CRUSH')",
                  },
                ],
                staticClass: "field-body",
              },
              [
                _c("div", { staticClass: "field is-narrow" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Crush Hour")]),
                  _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _c("vue-numeric", {
                        staticClass: "input has-text-right",
                        attrs: { min: 0.0, precision: 2 },
                        model: {
                          value: _vm.value.crushHour,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "crushHour", _vm._n($$v))
                          },
                          expression: "value.crushHour",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isCD && _vm.isLabourTypeVisible("CD"),
                    expression: "isCD && isLabourTypeVisible('CD')",
                  },
                ],
                staticClass: "field-body",
              },
              [
                _c("div", { staticClass: "field is-narrow" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Clean and Detail Hour"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _c("vue-numeric", {
                        staticClass: "input has-text-right",
                        attrs: { min: 0.0, precision: 2 },
                        model: {
                          value: _vm.value.cdHour,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "cdHour", _vm._n($$v))
                          },
                          expression: "value.cdHour",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isMech && _vm.isLabourTypeVisible("MECH"),
                    expression: "isMech && isLabourTypeVisible('MECH')",
                  },
                ],
                staticClass: "field-body",
              },
              [
                _c("div", { staticClass: "field is-narrow" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Mechanical Hour"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _c("vue-numeric", {
                        staticClass: "input has-text-right",
                        attrs: { min: 0.0, precision: 2 },
                        model: {
                          value: _vm.value.mechHour,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "mechHour", _vm._n($$v))
                          },
                          expression: "value.mechHour",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ]),
          _c("div", { staticClass: "is-divider" }),
          _c("div", { staticClass: "field" }, [
            _c("div", { staticClass: "buttons has-addons is-centered" }, [
              _c(
                "span",
                {
                  staticClass: "button",
                  class: { "is-success is-selected": _vm.value.active },
                  on: {
                    click: function ($event) {
                      return _vm.toggleActive(true)
                    },
                  },
                },
                [_vm._m(1), _c("span", [_vm._v("Active")])]
              ),
              _c(
                "span",
                {
                  staticClass: "button",
                  class: { "is-danger is-selected": !_vm.value.active },
                  on: {
                    click: function ($event) {
                      return _vm.toggleActive(false)
                    },
                  },
                },
                [_vm._m(2), _c("span", [_vm._v("In-Active")])]
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "columns is-gapless" }, [
      _c("div", { staticClass: "column" }, [
        _c("p", { staticClass: "title" }, [_vm._v("Detail Info")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-check" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-close" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }